import * as tslib_1 from "tslib";
import React from 'react';
import { useBiLogger } from '../hooks/useBiLogger';
export var withLogBiEvent = function (Component) {
    var ComponentWithLogBiEvent = function (props) {
        var logBiEvent = useBiLogger();
        return React.createElement(Component, tslib_1.__assign({}, props, { logBiEvent: logBiEvent }));
    };
    ComponentWithLogBiEvent.displayName = "WithLogBiEvent(" + (Component.displayName ||
        Component.name ||
        'Component') + ")";
    return ComponentWithLogBiEvent;
};
export default withLogBiEvent;
//# sourceMappingURL=withLogBiEvent.js.map